/**
 * 商品詳細ページの店舗在庫状況
 */
export default class ProductStock extends HTMLElement {
  constructor() {
    super();

    this.listBlock = this.querySelector(".unico-stock-list");
    this.accButton = this.querySelector(".unico-button");
    this.productType = this.dataset.productType;

    this.accButton.addEventListener("click", () => {
      this.toggleOpen();
    });
    
    this.initStockInventory();
  }

  initStockInventory() {

    // fetch
    const sku = this.dataset.sku;
    const qtyThreshold = this.dataset.qtyThreshold;
    const fewText = this.dataset.fewCartBtn;
    const soldoutText = this.dataset.soldoutCartBtn;
    const normalText = this.dataset.addToCartBtn;

    fetch('/apps/unico-custom-app/store-inventory', {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({product_code: sku}),
    })
    .then(response => response.json())
    .then(data => {
      if (data.error_code === "00000") {
        const stockData = data.shop;

        if (this.productType === 'furniture') {
          const displayedItems = stockData.filter(item => item.ShouhinRankKBN === '3');
          const isSoldOut = displayedItems.every(item => item.Suuryou === '0');
    
          if (isSoldOut) {
            this.listBlock.innerHTML = `<p class="unico-heading4 center">現在展示のある店舗はございません。</p>`;
            this.accButton.parentElement.classList.add("hidden");
          } else {
            let countStore = 0;
            displayedItems.forEach(item => {
              const unicoStockItem = this.listBlock.querySelector(`[data-store*="${item.TenpoCD}"]`);
              if (unicoStockItem) {
                const status = unicoStockItem.querySelector('.unico-stock-heading-status');
                if (+item.Suuryou > 0) {
                  countStore++;
                  unicoStockItem.classList.remove("hidden");
                  status.textContent = `○ 展示中`;
                } else {
                  unicoStockItem.classList.add("hidden");
                  // Remove the element from the DOM
                  unicoStockItem.remove();
                }
              }
            });
    
            if (countStore < 4) {
              this.accButton.parentElement.classList.add("hidden");
            }
          }
        } else {
          const inventoryItems = stockData.filter(item => item.ShouhinRankKBN === '0');
    
          inventoryItems.forEach(item => {
            const unicoStockItem = this.listBlock.querySelector(`[data-store*="${item.TenpoCD}"]`);
            if (unicoStockItem) {
              const status = unicoStockItem.querySelector('.unico-stock-heading-status');
              if (+item.Suuryou == 0) {
                status.textContent = `× ${soldoutText}`;
              } else if (+item.Suuryou > +qtyThreshold) {
                status.textContent = `○ ${normalText}`;
              } else {
                status.textContent = `△ ${fewText}`;
              }
            }
          });
        }    
      } 
    })
    .catch(err => console.error('Error fetching data inventory stock:', err));
  }

  toggleOpen() {
    if (this.accButton.classList.contains("-is-active")) {
      this.accButton.classList.remove("-is-active");
      this.listBlock.classList.remove("-is-active");
      this.accButton.innerHTML = "すべて表示する";

      this.listBlock.closest("unico-product-stock").scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      this.accButton.classList.add("-is-active");
      this.listBlock.classList.add("-is-active");
      this.accButton.innerHTML = "閉じる";
    }
  }
}
